const brandKeys = [
    "Brand"
];

const accountingSoftwareKeys = [
    "AccountingSoftware",
    "AccountingSoftwareSingle",
    "AccountingSoftwareLedgers",
    "AccountingSoftwareTaxRates",
    "AccountingSoftwareRelations"
];

const batchKeys = [
    "Batch"
]

const claimKeys = [
    "Claim",
    "Claim-List"
];

const carrierKeys = [
    "Carriers",
    "CarriersSingle",
    "CarriersSingleBarcode",
    "CarriersStock"
];

const countingStrategyKeys = [
    "CountingStrategies",
    "CountingStrategySingle"
];

const countingStrategyTemplateKeys = [
    "CountingStrategyTemplates",
    "CountingStrategyTemplatesSingle"
];

const generalKeys = [
    "enums"
];

const globalRelationKeys = [
    "Relations",
    "RelationsSingle",
    "RelationContacts",
    "RelationInvoiceProducts"
];

const globalStreamKeys = [
    "Streams",
    "StreamsSingle"
];

const globalSupplierKeys = [
    "Suppliers",
    "SuppliersSingle"
];

const globalGeneralKeys = [
    "Settings",
    "Onboarding"
];

const importOrderKeys = [
    "ImportOrders"
];

const inboundKeys = [
    "Inbound",
    "Inbounds",
    "InboundSingle",
    "InboundDashboard",
    "InboundsCounts",
    "InboundLines",
    "InboundShipments",
    "InboundPhotos",
    "InboundLinePhotos"
];

const invoiceKeys = [
    "Invoices",
    "InvoiceSingle",
    "InvoiceLines",
    "LogsInvoice",
    "ConceptInvoiceProducts",
    "OrdersWithoutCosts",
    "InvoiceMutations",
    "ShippingCostOverview",
    "NoCostsCount"
];

const invoiceCategoryKeys = [
    "InvoiceCategories",
    "InvoiceCategorySingle"
];

const invoiceProductKeys = [
    "InvoiceProducts",
    "InvoiceProductSingle"
];

const logKeys = [
    "InboundLogs",
    "LogsSingle",
    "OrderLogs",
    "ProductLogs"
];

const lotKeys = [
    "Lots",
    "LotsSingle"
]

const operatingHoursKeys = [
    "OperatingHours",
    "OperatingHoursSingle"
];

const orderKeys = [
    "Orders",
    "OrdersSingle",
    "OrdersStatusCounts",
    "DashboardOrdersStatusCounts",
    "OrderLines",
    "OrderColli",
    "OrderMutations",
    "OrderEvents",
    "OrderPickingLines",
    "OrderTotals"
];

const palletspotKeys = [
    "Palletspots"
];

const pickingjobKeys = [
    "PickingJobs",
    "PickingJobsSingle",
    "OrderPickingList",
    "PickingJobPickingLines"
];

const priceIncreaseKeys = [
    "PriceIncreases",
    "PriceIncreaseSingle"
];

const productKeys = [
    "ChildProducts",
    "Products",
    "ProductsSingle",
    "StockForecast"
];

const productFieldKeys = [
    "ProductFields"
];

const reachTypeKeys = [
    "ReachTypes"
];

const repackingKeys = [
    "RepackingOrders",
    "RepackingOrdersSingle"
]

const replenishLineKeys = [
    "ReplenishLines"
];

const replenishListKeys = [
    "ReplenishLists",
    "ReplenishListsSingle",
    "ReplenishListsListItems"
];

const returnKeys = [
    "Returns",
    "ReturnLines",
    "ReturnsSingle",
    "PortalReturnsWithoutShipmentsThatArePaid",
];

const relationAddressKeys = [
    "RelationAddresses",
    "RelationAddressesSingle"
];

const shipperKeys = [
    "Shippers",
    "ShippersSingle",
    "Surcharges"
];

const shippingOptionsKeys = [
    "ShippingOptions"
];

const supplierKeys = [
    "Suppliers",
    "SuppliersSingle"
];

const stockKeys = [
    "Stock",
    "StockMutations",
];

const mfaKeys = [
    "MfaStatus"
];

const userKeys = [
    "Usergroups"
];

const userGroupKeys = [
    "Usergroups",
    "UsergroupSingle"
];

const warehouseKeys = [
    "Warehouse",
    "Warehouses",
    "WarehousesSelect",
    "WarehouseLocations",
    "WarehouseZones",
    "WarehouseLevels",
    "WarehouseReplenishOrder"
];

const warehouseLocationKeys = [
    "WarehouseLocations"
];

const warehouseLocationTypeKeys = [
    "WarehouseLocationTypes"
];

const webshopKeys = [
    "WebshopCredentials",
    "WebshopCredentialsSingle",
    "AmazonReplenishments",
    "AmazonReplenishmentLines"
];

const openapikeyKeys = [
    "Openapikey",
    "OpenapikeySingle"
];

const workflowTemplateKeys = [
    "WorkflowTemplates",
    "WorkflowTemplatesSingle"
];

const workflowKeys = [
    "Workflows",
    "WorkflowSingle",
    "WorkflowLogs"
];

const newsKeys = [
    "Articles",
    "ArticleSingle",
    "NewsFeed",
    "NewsArchive",
    "ActiveMeldingen"
];

const relationNewsKeys = [
    "RelationNews",
    "RelationNewsSingle",
    "RelationNewsArchive",
];

const emailTemplateKeys = [
    "EmailTemplates",
    "EmailTemplatesSingle",
    "EmailTemplateTypes",
    "EmailTemplateSalesChannels",
    "EmailTemplateShipments",
    "EmailTemplateShipmentPreview",
];

const pwaKeys = [
    "PushSubscriptions",
    "NotificationPreferences",
    "NotificationHistory",
    "NotificationStats",
    "VapidKeys",
    "UserDevices",
    "NotificationTemplates",
    "ScheduledNotifications"
];

const tableSettingsKeys = [
    "TableSettings"
];

const supportTicketKeys = [
    "SupportTickets",
    "SupportTicketSingle",
    "SupportTicketMessages",
    "SupportTicketAttachments",
    "SupportTicketLinkedItems",
    "SupportTicketLabels",
    "SupportTicketDashboard",
    "SupportTicketLabelsCrud",
    "SupportTicketUpdates"
];

const echeckKeys = [,
    "PickingJobs",
    "AllPickingJobs",
    "ConceptPickingJobs",
    "PickingJobPickingLines"
]

const businessIntelligenceKeys = [
    "BusinessIntelligence",
    "BusinessIntelligenceMenu",
    "BusinessIntelligenceReports",
    "BusinessIntelligenceDashboards",
];

const subscriptionKeys = [
    "Subscription"
]

const invoicingConfigKeys = [
    "InvoicingConfig"
];

const feedbackKeys = [
    "Feedback",
    "AdminFeedback",
    "WorkOrder"
];

export const cacheKeys = [
    'SoftwareOrders',
    ...brandKeys,
    ...accountingSoftwareKeys,
    ...batchKeys,
    ...carrierKeys,
    ...countingStrategyKeys,
    ...countingStrategyTemplateKeys,
    ...generalKeys,
    ...globalRelationKeys,
    ...globalStreamKeys,
    ...globalSupplierKeys,
    ...globalGeneralKeys,
    ...importOrderKeys,
    ...inboundKeys,
    ...invoiceKeys,
    ...invoiceCategoryKeys,
    ...invoiceProductKeys,
    ...logKeys,
    ...lotKeys,
    ...mfaKeys,
    ...newsKeys,
    ...relationNewsKeys,
    ...emailTemplateKeys,
    ...operatingHoursKeys,
    ...orderKeys,
    ...palletspotKeys,
    ...pickingjobKeys,
    ...priceIncreaseKeys,
    ...productKeys,
    ...productFieldKeys,
    ...reachTypeKeys,
    ...repackingKeys,
    ...replenishLineKeys,
    ...replenishListKeys,
    ...returnKeys,
    ...relationAddressKeys,
    ...shipperKeys,
    ...shippingOptionsKeys,
    ...stockKeys,
    ...supplierKeys,
    ...userKeys,
    ...userGroupKeys,
    ...warehouseKeys,
    ...warehouseLocationKeys,
    ...warehouseLocationTypeKeys,
    ...webshopKeys,
    ...openapikeyKeys,
    ...workflowTemplateKeys,
    ...workflowKeys,
    ...pwaKeys,
    ...tableSettingsKeys,
    ...echeckKeys,
    ...supportTicketKeys,
    ...businessIntelligenceKeys,
    ...feedbackKeys,
    ...subscriptionKeys,
    ...invoicingConfigKeys,
    ...claimKeys,
];
